module.exports = __webpack_public_path__ + "./assets/img_kao_color__896c86f6951593d238def6f26f566113.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_kao_color.jpg
// module id = 609
// module chunks = 12